import { interpolate } from '../../utils/utils';

export const getCurrencySymbol = (currency: string, locale: string): string => {
  try {
    return (0)
      .toLocaleString(locale, {
        style:                 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })
      .replace(/\d/g, '')
      .trim();
  } catch {
    return currency;
  }
};

export const sanitizeAmountInput = (value: string): string => value
  .split(/[.,]/)[0]
  .replace(/\D/g, '')
  .replace(/^0+(?=\d)/, '');

export const validateAmount = (
  value: string,
  min: number,
  max: number,
  content: { errorInvalid: string; errorMin: string; errorMax: string },
  currencySymbol: string,
): string | null => {
  const trimmed = value.trim();
  if (!trimmed) return content.errorInvalid;

  const num = Number(trimmed);
  if (isNaN(num) || !isFinite(num) || num <= 0) return content.errorInvalid;

  const format = (n: number) => `${n}${currencySymbol}`;

  if (num < min) return interpolate(content.errorMin, { min: format(min) });
  if (num > max) return interpolate(content.errorMax, { max: format(max) });

  return null;
};
